import {List} from "immutable";

export default {
  // Cache data
  vessel_id: null,
  my_points: [],
  area_points: List(),
  area_vessels: {},

  // Camera
  camera_list: [],

  // Ticker
  current_time: null,
  start_time: null,
  end_time: null,
  is_pause: true,
  fps: 1,
  buffered_percent: 0,

  buffer_start_time: 0,

  buffered_map: {},

  is_waiting_buffered: false,

  myVesselId: null,
  myTracks: null,
  vesselMapObjects: {},
  chunkPoints: [],
  startPointGeoJson: null,

};
